export default "__VITE_ASSET__9ewB3HNT__"